import { useMemo } from 'react';
import useFeatures from '@/hooks/useFeatures';
import useFuelOverview from './useFuelOverview';

const EMPTY = new Map();

/** deviceId -> Fuel overview row, for the shared level resolver. Empty (and no request) when the module is off. */
export default function useFuelLevels() {
  const features = useFeatures();
  const { data } = useFuelOverview({ enabled: Boolean(features.fuel) });
  const byDevice = useMemo(
    () => (features.fuel && data?.vehicles ? new Map(data.vehicles.map((v) => [v.deviceId, v])) : EMPTY),
    [features.fuel, data],
  );
  return { byDevice };
}
